import type { AuthN } from '@seek/online-identity';

import { sleep } from '../../utils/sleep';

export const awaitLoginWithRedirect = async (authN: AuthN) => {
  await authN.login({
    returnUri: window.location.href.replace(window.location.origin, ''),
  });
  await sleep(1000);
};
